import { render, staticRenderFns } from "./base-list.vue?vue&type=template&id=fdf2dd8c&scoped=true"
import script from "./base-list.vue?vue&type=script&lang=js"
export * from "./base-list.vue?vue&type=script&lang=js"
import style0 from "./base-list.vue?vue&type=style&index=0&id=fdf2dd8c&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf2dd8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdf2dd8c')) {
      api.createRecord('fdf2dd8c', component.options)
    } else {
      api.reload('fdf2dd8c', component.options)
    }
    module.hot.accept("./base-list.vue?vue&type=template&id=fdf2dd8c&scoped=true", function () {
      api.rerender('fdf2dd8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base-list.vue"
export default component.exports